import * as React from 'react';

var _circle, _circle2, _path, _circle3, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDeliveryOutline24 = function SvgDeliveryOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.16,
    cy: 21.6,
    stroke: "currentColor",
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.76,
    cy: 21.6,
    stroke: "currentColor",
    r: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76 22.08h-.88a2 2 0 0 1-2-2v-8.56m7.68 10.56h4.8m4.32 0H22a2 2 0 0 0 2-2v-4.719a2 2 0 0 0-.75-1.562l-1.102-.88a2 2 0 0 0-1.25-.439H17.76m0 6.72v-6.64a2 2 0 0 0-2-2h-4.24M24 16.32h-3.36",
    stroke: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.72,
    cy: 6.72,
    r: 6.22,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.56 6.72H6.72v-4.8",
    stroke: "currentColor"
  })));
};

var DeliveryOutline24Svg = SvgDeliveryOutline24;

export { DeliveryOutline24Svg as default };
//# sourceMappingURL=DeliveryOutline24.svg.js.map
